import _ from 'lodash';
// import math from 'mathjs';
import { create, all } from 'mathjs'
import FIELDS from '../config/fields-config';

const math = create(all, {});

export const calculateRegionTotal = (region, data, dataField) => {
    if(!data) return 0;
    return _.sum(region.sections.map(section => calculateSectionTotal(section, data, dataField)));
}

export const getOtherTotals = (region, section, data) => {
    if(!data || !section.otherTotalFields || !_.isArray(section.otherTotalFields)) return null;
    
    const output    = {};
    const fields    = section.otherTotalFields;
    for(var i = 0; i < fields.length; i++){
        const field     = _.find(FIELDS, f => f.id === fields[i]);
        if(field.isOptionTotals && field.options){
            //TODO: total things up by each option...            
            const list      = data[section.id];
            field.options.forEach(opt => {
                const filtered  = _.filter(list, li => ((li[field.id] == opt.id) || (opt.id === 0 && li[field.id] === undefined)));
                if(filtered.length > 0){
                    const total     = _.sumBy(filtered, f => f[field.optionsTotalField]);
                    const key       = `${field.id}_${opt.id}`;
                    output[key]     = total; 
                }
            });
        }
        else{
            const id        = `t_${region.id}_${section.id}_${fields[i]}`;
            output[id]      = calculateSectionTotal(section, data, fields[i]);
        }
    }

    return output;
}

export const calculateSectionTotal = (section, data, dataField) => {
    if(!data) return 0;
    
    if(section.condition){
        if(!isConditionMet(section.condition, data)) return 0;
    }

    const fields        = getFields(section.fields);
    
    if(section.type === "list"){
        //For a list, there are multiple rows, and one of the fields will be the field to total
        const rows          = data[section.id];
        if(!rows || rows.length === 0) return 0;

        const totalFieldId  = dataField || section.totalField;
        const totalField    = getField(totalFieldId); //dataField ? _.find(fields, f => f.id == dataField) : _.find(fields, f => f.isTotal);    
        if(!totalField) return 0;
        
        if(totalField.calculation){
            return sumCalculatedField(totalField, rows);
        }
        return _.sumBy(rows, d => d[totalField.id]);
    }
    else{
        const sectionData   = _.pick(data, section.fields);
        return _.sumBy(fields, f => isTotaled(f) ? sectionData[f.id] : 0);
    }
}

export const addRowTotals = (section, data) => {
    const rowData   = data[section.id];
    const tFields   = getFields(section.rowTotalFields);
    const updated   = _.map(rowData, row => {
        const rowTotals     =     _.reduce(tFields, (output, field) => {
            return {
                ...output,
                [field.id]    : calculateCalcField(field, row),
            };
        }, {});

        return {
            ...row,
            ...rowTotals,
        };
    });

    return updated;
}

export const addRowOptionNames = (section, data) => {
    const rowData   = data[section.id];
    const oFields   = getFields(section.addOptionNames);
    const updated   = _.map(rowData, row => {
        const names     =     _.reduce(oFields, (output, field) => {
            const fieldKey  = field.id + "Name";
            const val       = parseInt(row[field.id]);
            const name      = field.options[val];
            return {
                ...output,
                [fieldKey]   : name ? name.label : "- unknown -",
            };
        }, {});

        return {
            ...row,
            ...names,
        };
    });

    return updated;
}

export const calculateCalcField = (field, row) => {
    const expr      = math.parse(field.calculation);
    const varsFunc  = getCalculatedParameters(field.calculation);
    var p           = varsFunc(row);
    var val         = math.simplify(expr, p).evaluate();  
    return val;
}

export const sumField = (field, rows) => {
    rows    = _.compact(rows);
    if(!rows || rows.length === 0) return 0;
    
    if(field.calculation){
        return sumCalculatedField(field, rows);
    }
    else{
        return _.sumBy(rows, r => r ? r[field.id] : 0);
    }
}

const sumCalculatedField = (field, rows) => {
    const expr      = math.parse(field.calculation);
    const varsFunc  = getCalculatedParameters(field.calculation);

    let total       = 0;
    rows.forEach(row => {
        var p       = varsFunc(row);
        var val     = math.simplify(expr, p).evaluate();  
        total       += val;
    });

    return total; // _.sumBy(rows, d => d ? math.eval(expr, vars(d)) : 0);
}

const getCalculatedParameters = (formula) => {    
    return (d) => {
        const parts     = formula.split(" ");
        let vars        = {};
        for(var i = 0; i <= parts.length; i = i + 2){
            vars[parts[i]]  = d[parts[i]] || 0;
        }
        return vars;
    };
}

const calculateSummaryField = (field, data, regions) => {
    let calcStr     = field.calculation;
    const parts     = calcStr.split(" ");
    let vars        = {};
    for(var i = 0; i < parts.length; i = i + 2){
        let vKey    = parts[i];
        let vSubKey = null;
        
        if(vKey.indexOf("[") > 0){
            const orig  = vKey;
            const idx   = vKey.indexOf("[");
            vSubKey     = vKey.substr(idx + 1, vKey.length - idx - 2); 
            vKey        = vKey.substr(0, idx);
            calcStr     = calcStr.replace(orig, vKey);    //Need to update the calcStr so math can parse it
        }
        
        const vReg  = _.find(regions, r => r.id === vKey);
        const vVal  = calculateRegionTotal(vReg, data, vSubKey);
        vars[vKey]  = vVal || 0;
    }

    const expr      = math.parse(calcStr);
    const total     = math.simplify(expr, vars).evaluate();
    return total;
}

export const calculateSummaryRegion = (field, data, regions) => {
    let vKey        = field.regionId;
    let vSubKey     = null;
    
    //Deal with custom total keys, like: debts[balance] to sum the balance prop of the debts region
    if(vKey.indexOf("[") > 0){
        const idx   = vKey.indexOf("[");
        vSubKey     = vKey.substr(idx + 1, vKey.length - idx - 2); 
        vKey        = vKey.substr(0, idx);
    }
    
    const vReg  = _.find(regions, r => r.id == vKey);
    const vVal  = calculateRegionTotal(vReg, data, vSubKey);
    return vVal;
}

const toPairs = (array) => {
    return array.reduce((result, value, index, array) => {
        if (index % 2 === 0) result.push(array.slice(index, index + 2));
        return result;
      }, []);
}

const isTotaled = (field) => {
    return field && 
            (field.type === undefined || (field.type !== "question" && field.type !== "checkbox"));
    // return field && (!field.type || (field.type != "question"  && field.type != "checkbox");
}

const isNotQuestion =(field) => {
    return field && (!field.type || field.type !== "question");
}

const isConditionUndefined = (condition, data) => {
    if(condition){
        const parts     = condition.split(":");
        return !data || data[parts[0]] === undefined;
        // const condData  = data && data[parts[0]] ? data[parts[0]].toString() : undefined;
        // return condData === undefined;
    }

    return false;
}

const isConditionMet = (condition, data) => {
    if(condition){
        const parts     = condition.split(":");
        const condData  = data && (data[parts[0]] !== undefined) ? data[parts[0]].toString() : null;
        let value       = parts[2] === "null" ? null : parts[2];
        if(value.indexOf("[") >= 0 && value.indexOf("]") > 0){
            value = value.replace("[", "").replace("]","").split(",");
        }

        // value           = value;

        switch(parts[1]){
            case "="        : 
                if(_.isArray(value)) return value.indexOf(condData) >= 0;
                else return condData === value;      //the data matches the condition value

            case "!="       : 
                if(_.isArray(value)) return value.indexOf(condData) < 0;
                else return condData !== value;
                
            //TODO: Deal with other comparison operators...
            default: return false;
        }
    }

    return true;
}

const isConditionMet2 = (condition, condData) => {
    if(condition){
        const parts     = condition.split(":");
        // const condData  = data && (data[parts[0]] !== undefined) ? data[parts[0]].toString() : null;
        let value       = parts[2] === "null" ? null : parts[2];
        if(value.indexOf("[") >= 0 && value.indexOf("]") > 0){
            value = value.replace("[", "").replace("]","").split(",");
        }

        // value           = value;

        switch(parts[1]){
            case "="        : 
                if(_.isArray(value)) return value.indexOf(condData) >= 0;
                else return condData === value;      //the data matches the condition value

            case "!="       : 
                if(_.isArray(value)) return value.indexOf(condData) < 0;
                else return condData !== value;
                
            //TODO: Deal with other comparison operators...
            default: return false;
        }
    }

    return true;
}

const getField = (fieldId, raiseError = true) => {
    if(!_.isString(fieldId)){
        if(raiseError) console.error("Invalid Field Id provided", fieldId);
        return null;
    }
    const field     = _.find(FIELDS, {id: fieldId});    
    if(!field && raiseError) console.error("Unrecognized field: " + fieldId);
    return field;
}

const getFields = (idList, raiseError = true) => {
    if(idList === "*") return FIELDS;
    return _.map(idList, id => getField(id, raiseError));
}

function generateUid() {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
      var r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8);
      return v.toString(16);
    });
}

export default {
    calculateRegionTotal    : calculateRegionTotal,
    calculateSectionTotal   : calculateSectionTotal,
    calculateCalcField      : calculateCalcField,
    calculateSummaryField   : calculateSummaryField,
    calculateSummaryRegion  : calculateSummaryRegion,
    toPairs                 : toPairs,
    isNotQuestion           : isNotQuestion,
    isConditionMet          : isConditionMet,
    isConditionMet2         : isConditionMet2,
    isConditionUndefined    : isConditionUndefined,
    sumField                : sumField,
    getField                : getField,
    getFields               : getFields,
    getOtherTotals          : getOtherTotals,
    addRowTotals            : addRowTotals,
    addRowOptionNames       : addRowOptionNames,
    generateUid             : generateUid,
};